module.exports = __webpack_public_path__ + "img/P1.1f39796.png";